import { gql } from '@apollo/client';

export const CREATE_TOOL = gql`
  mutation CreateTool($input: CreateToolInput!) {
    createTool(input: $input) {
      tool {
        id
        name
        description
        toolAvailabilityPeriods {
          id
          startDate
          endDate
          available
        }
      }
      errors
    }
  }
`;
